import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchCallsListData, updateCallsListData } from "../../apis/calls";

export const fetchCallsList = createAsyncThunk(
  "callList/fetchCallsList",
  async (
    {
      params,
      sort,
      page
    }: {
      params: { [key: string]: string | number };
      sort: { field: string; direction: string };
      page?: number;
    },
    { rejectWithValue }
  ) => {
    try {
      return await fetchCallsListData(params, sort,page);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateCallsList = createAsyncThunk(
  "callList/updateCallsList",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        [key: string]: any;
        callId: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const result = await updateCallsListData(id, data);
      return result.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
